import { Fragment, useEffect } from "react";
import { Footer, Nav, Pricing } from "./landing-page";
import { NextUIProvider } from "@nextui-org/react";
import { DefaultMetaTags } from "@common/seo/default-meta-tags";
import { useLocation } from "react-router-dom";

export default function Plans() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1));
      if (element) {
        const offset = 100;
        const elementPosition = element.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({ top: elementPosition - offset, behavior: "smooth" });
      }
    }
  }, [location]);
  
  return (
    <Fragment>
      <NextUIProvider>
        <DefaultMetaTags />
        <div>
          <Nav />
          <Pricing />
          <Footer />
        </div>
      </NextUIProvider>
    </Fragment>
  )
}
